$(document).ready(function() {
console.log("reactiveUV init slider");
var TotalSlideNum = 5;    
$('#gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    pauseOnHover: false,
    cssEase: 'linear'
  });

  $('input[type="radio"]').click(function(){
        var inputValue = $(this).attr("value");
        var targetBox = $("#reactiveUV-" + inputValue);
        $(".description").not(targetBox).hide();
        $(targetBox).show();

   
    });  
   
    $(".btnprev").click(function(){
       var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
       var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
       console.log("on slideNum", slideNum)
        if (slideNum > 1 && slideNum <= 5){
            var cslideNum  = slideNum - 1  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#reactiveUV-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        
        }else if (slideNum == 1 ){
            var cslideNum  = 5  ;
            var curSlideId = "s"+ cslideNum.toString();
            console.log("curSlideId", curSlideId)
            $('#'+curSlideId).prop("checked", true);
            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#reactiveUV-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });
    $(".btnnext").click(function(){
        var currentLensId = $('input[type=radio][name=slider]:checked').attr('id')
        var slideNumStr = currentLensId.replace("s", "");
        var slideNum = parseInt(slideNumStr);
     
       console.log("on slideNum", slideNum)
        if (slideNum > 0 && slideNum < 5){
            var cslideNum  = slideNum + 1 ;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#reactiveUV-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();

        }else if (slideNum = TotalSlideNum ){
            var cslideNum  = 1;
            var curSlideId = "s"+ cslideNum.toString();
            $('#'+curSlideId).prop("checked", true);

            var inputValue = $("#"+curSlideId).attr("value");
            var targetBox = $("#reactiveUV-" + inputValue);
           $(".description").not(targetBox).hide();
           $(targetBox).show();
        }
    });


})

